var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDelivery = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76 84C82.6274 84 88 78.6274 88 72C88 65.3726 82.6274 60 76 60C69.3726 60 64 65.3726 64 72C64 78.6274 69.3726 84 76 84Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32 34C32 30.688 29.312 28 26 28C24.456 28 15.544 28 14 28C10.688 28 8 30.688 8 34C8 35.544 8 36.456 8 38C8 41.312 10.688 44 14 44C15.544 44 24.456 44 26 44C29.312 44 32 41.312 32 38C32 36.456 32 35.544 32 34Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M36 18C36 14.688 33.312 12 30 12C28.456 12 19.544 12 18 12C14.688 12 12 14.688 12 18C12 19.544 12 20.456 12 22C12 25.312 14.688 28 18 28C19.544 28 28.456 28 30 28C33.312 28 36 25.312 36 22C36 20.456 36 19.544 36 18Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64 16C62.972 16 57.028 16 56 16C53.792 16 52 17.792 52 20C52 22.208 53.792 24 56 24C57.028 24 62.972 24 64 24C66.208 24 68 22.208 68 20C68 17.792 66.208 16 64 16Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20 84C26.6274 84 32 78.6274 32 72C32 65.3726 26.6274 60 20 60C13.3726 60 8 65.3726 8 72C8 78.6274 13.3726 84 20 84Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3041 50.94C85.2121 50.94 92.0001 60 92.0001 64C92.0001 68 88.0001 68 84.0001 68C80.0001 68 61.0361 68.056 61.0361 68.056L71.3041 50.94Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66 24H74C75.104 24 76 23.104 76 22V14C76 12.896 75.104 12 74 12H66C62.688 12 60 14.688 60 18C60 21.312 62.688 24 66 24Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 16L60.0001 18C60.0001 24.16 64.0001 28.22 64.0001 40C64.0001 52 62.8441 56 56.0001 56H44.0001V52C44.0001 47.58 40.4201 44 36.0001 44H16.0001C12.6841 44 6.62415 47.936 4.64415 55.124C3.92415 57.736 5.30015 60.488 7.83615 61.436L33.9641 71.232C35.3081 71.74 36.7361 72 38.1761 72H55.0281C58.2122 72 61.2641 70.736 63.5121 68.484L80.0001 52C79.7521 36.376 72.0002 24 64.0001 16Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelivery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delivery.a14e44cc.svg";
export { ForwardRef as ReactComponent };